// eslint-disable-next-line import/no-named-as-default
import { useProjectContext } from "components/project/projects/context";
import { useSelectedProjectPermissions } from "components/project/projects/hooks";
import { useCreateProjectShapefileFolder } from "components/project/shapefiles/hooks/createProjectShapefileFolder/useCreateProjectShapefileFolder";
import { useSortProjectShapefilesInFolderMutation } from "components/project/shapefiles/mutations";

import { UseRightClickContextMenuReturn } from "../hooks/useRightClickContextMenu";
import { ShapefileFolderActions } from "./ShapefileFolderActions";

interface IProjectShapefileFolderActionsProps {
  newFolderPosition: number;
  shapefileNodeId: string;
  contextMenu?: UseRightClickContextMenuReturn;
  folderName: string;
}

/**
 * Some actions and properties have been left for dev to implement based on use case, since the properties are different between
 * the layer tree layers, and layer list layers.
 * @param params
 * @returns
 */
export function RootFolderActions(
  params: IProjectShapefileFolderActionsProps
): JSX.Element {
  const projectPermissions = useSelectedProjectPermissions();
  const { selectedProjectId } = useProjectContext();

  const sortProjectShapefilesInFolderMutation = useSortProjectShapefilesInFolderMutation({
    projectId: selectedProjectId
  });

  const createProjectFolder = useCreateProjectShapefileFolder({
    projectId: selectedProjectId
  });
  return (
    <ShapefileFolderActions
      addFolder={() =>
        createProjectFolder.mutate({
          parentId: "",
          order: params.newFolderPosition
        })
      }
      hasSelectItems={true}
      folderName={params.folderName}
      isDisabled={!projectPermissions.canEditShapefiles}
      sortShapefilesAscend={() =>
        sortProjectShapefilesInFolderMutation.mutate({
          shapefileNodeId: params.shapefileNodeId,
          order: "asc"
        })
      }
      sortShapefilesDescend={() =>
        sortProjectShapefilesInFolderMutation.mutate({
          shapefileNodeId: params.shapefileNodeId,
          order: "desc"
        })
      }
      contextMenu={params.contextMenu}
      {...params}
    />
  );
}
